
export default {
  props: {
    position: {
      // 右侧图片位置
      type: String,
      default: '-16px, -26px'
    },
    isbg: {
      // 右侧是否有背景
      type: Boolean,
      default: true
    },
    isvalue: {
      // 是否选中
      type: Boolean,
      default: false
    },
    item: {
      // 数据
      type: Object,
      default: () => {}
    }
  }
}
